// src/data/scopeCap.js
//
// T5 item 20 (2026-10-15): ONE PLACE for the 30-territory cap. Every territory-scoped listing (claims, discipline,
// notifications, obligations, reviews, applications, the LC desk) runs one query per scopeKey and stops at 30. Two
// pages (Claims, LCDesk) said so; seven cut silently - the shape the 09-19 list calls silent truncation rendering as an
// empty result. Now every site takes its list from capScopes(), and App.js shows ONE banner, on every page, naming
// the territories past the cap (scopeCapNotice). Pure.
export const SCOPE_QUERY_CAP = 30;

export function capScopes(user) {
  const all = (user && Array.isArray(user.scopes) ? user.scopes : []).filter(Boolean);
  return { scopes: all.slice(0, SCOPE_QUERY_CAP), dropped: all.slice(SCOPE_QUERY_CAP), total: all.length };
}

// null when nothing is cut; otherwise the words the banner shows.
export function scopeCapNotice(user) {
  const c = capScopes(user);
  if (!c.dropped.length) return null;
  return 'Your account holds ' + c.total + ' territories. Lists on this platform read the first ' + SCOPE_QUERY_CAP
    + '; these ' + c.dropped.length + ' are NOT shown anywhere: ' + c.dropped.join(', ') + '. Ask the administrator to split the account.';
}
